import { AppBar, Avatar, Box, Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, MenuItem, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import { Add, ArrowBack, Delete, Edit, Extension } from '@material-ui/icons';
import ListIcon from '@material-ui/icons/List';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Page from '../../containers/Page/Page';
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface IOpcao {
    id?: string;
    codigo_sap: string;
    opcao: string;
    upk: string;
    valor: string;
    usd: string;
}

interface IPreco {
    id?: string;
    label: string;
    tipo_campo: string;
    opcoes?: IOpcao[];
}

interface IParams {
    id: string;
}

function PrecosVariantesCreate() {

    const classes = useStyles();
    const history = useHistory();
    const params = useParams<IParams>();

    const { enqueueSnackbar: alert } = useSnackbar();

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [opcao, setOpcao] = React.useState<IOpcao>({} as IOpcao);
    const [preco, setPreco] = React.useState<IPreco>({} as IPreco);
    const [precos, setPrecos] = React.useState<IPreco[]>([]);
    const [opcoesDialog, setOpcoesDialog] = React.useState<boolean>(false);
    const [tab, setTab] = React.useState<number>(0);
    const [editDialog, setEditDialog] = React.useState<boolean>(false);
    const [editValue, setEditValue] = React.useState<IPreco>({} as IPreco);
    const [addLoading, setAddLoading] = React.useState<boolean>(false);
    const [saveLoading, setSaveLoading] = React.useState<boolean>(false);

    const tiposCampos = {
        "dropdown": "Dropdown",
        "checkbox": "Checkbox",
        "radio": "Radio",
    };

    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function handleFetch(load = true) {
        setLoading(load);
        try {
            const response = await api.get(`especiais/${params.id}`);
            setPrecos(response.data.object);
            setError('');
        } catch (error) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    async function addPreco() {
        if (preco.label && preco.tipo_campo) {
            setAddLoading(true);
            try {
                const response = await api.post('especiais', {
                    ...preco,
                    tipo_variante: decodeURI(params.id)
                });
                await handleFetch(false);
                alert(response.data.message, { variant: 'success' });
                setPreco({} as IPreco);
            } catch (error) {
                Helpers.error(error, alert);
            }
            setAddLoading(false);
        }
    }

    function editPreco(preco: IPreco) {
        setTab(0);
        setOpcao({} as IOpcao);
        setEditValue(preco);
        setEditDialog(true);
    }

    async function savePreco() {
        if (editValue.label && editValue.tipo_campo) {
            setSaveLoading(true);
            try {
                const response = await api.put('especiais/1', {
                    ...editValue,
                    tipo_variante: decodeURI(params.id)
                });
                await handleFetch(false);
                alert(response.data.message, { variant: 'success' });
                setEditValue({} as IPreco);
            } catch (error) {
                Helpers.error(error, alert);
            }
            setSaveLoading(false);
            setEditDialog(false);
        }
    }

    function removePreco(preco: IPreco) {
        setPrecos(precos => precos.filter(c => c !== preco));
    }

    function openOpcoesDialog() {
        setOpcao({} as IOpcao);
        setOpcoesDialog(true);
    }

    function addOpcao() {
        if (opcao.codigo_sap && opcao.opcao && opcao.upk && opcao.valor && opcao.usd) {
            let newOpcoes = preco.opcoes || [];
            newOpcoes.push(opcao);
            let newPreco = { ...preco, opcoes: newOpcoes };
            setPreco(newPreco);
            setOpcao({} as IOpcao);
        }
    }

    function addEditOpcao() {
        if (opcao.codigo_sap && opcao.opcao && opcao.upk && opcao.valor && opcao.usd) {
            let newOpcoes = editValue.opcoes || [];
            newOpcoes.push(opcao);
            let newPreco = { ...editValue, opcoes: newOpcoes };
            setEditValue(newPreco);
            setOpcao({} as IOpcao);
        }
    }

    function removeOpcao(opcao: IOpcao) {
        let newOpcoes = preco.opcoes || [];
        newOpcoes = newOpcoes.filter(d => d !== opcao);
        let newPreco = { ...preco, opcoes: newOpcoes };
        setPreco(newPreco);
    }

    function removeEditOpcao(opcao: IOpcao) {
        let newOpcoes = editValue.opcoes || [];
        newOpcoes = newOpcoes.filter(d => d !== opcao);
        let newPreco = { ...editValue, opcoes: newOpcoes };
        setEditValue(newPreco);
    }

    function changeOpcao(key: keyof IOpcao, opcao: IOpcao, value: string) {
        if (preco.opcoes) {
            let index = preco.opcoes.indexOf(opcao);
            let newOpcoes = preco.opcoes || [];
            newOpcoes[index] = { ...opcao, [key]: value };
            setPreco({ ...preco, opcoes: newOpcoes });
        }
    }

    function changeEditOpcao(key: keyof IOpcao, opcao: IOpcao, value: string) {
        if (editValue.opcoes) {
            let index = editValue.opcoes.indexOf(opcao);
            let newOpcoes = editValue.opcoes || [];
            newOpcoes[index] = { ...opcao, [key]: value };
            setEditValue({ ...editValue, opcoes: newOpcoes });
        }
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <IconButton size="small" color="primary" className={classes.backButton} onClick={() => history.goBack()}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" component="div">
                        {`Editar Preço: ${decodeURI(params.id)}`}
                    </Typography>
                </Box>
            </Page.Title>
            <Page.Section>
                <Page.Content>
                    <Box p={2}>
                        <Grid className={classes.row} container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="label"
                                    name="label"
                                    label="Nome do Campo"
                                    variant="outlined"
                                    fullWidth={true}
                                    value={preco.label || ''}
                                    onChange={(event) => setPreco({ ...preco, label: event.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="tipo_campo"
                                    name="tipo_campo"
                                    label="Tipo do Campo"
                                    variant="outlined"
                                    select={true}
                                    fullWidth={true}
                                    value={preco.tipo_campo || ''}
                                    onChange={(event) => setPreco({ ...preco, tipo_campo: event.target.value })}
                                >
                                    {Object.entries(tiposCampos).map((tipoCampo) => (
                                        <MenuItem
                                            key={tipoCampo[0]}
                                            value={tipoCampo[0]}>
                                            {tipoCampo[1]}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <Button
                                    style={{ height: '100%' }}
                                    color="secondary"
                                    variant="contained"
                                    startIcon={<ListIcon />}
                                    fullWidth={true}
                                    onClick={() => openOpcoesDialog()}>
                                    Opções
                                </Button>
                            </Grid>
                            <Dialog open={opcoesDialog} fullWidth={true} maxWidth="md">
                                <DialogTitle>Opções</DialogTitle>
                                <DialogContent>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Código SAP"
                                                variant="outlined"
                                                size="small"
                                                fullWidth={true}
                                                value={opcao.codigo_sap || ''}
                                                onChange={(event) => setOpcao({ ...opcao, codigo_sap: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Opção"
                                                variant="outlined"
                                                size="small"
                                                fullWidth={true}
                                                value={opcao.opcao || ''}
                                                onChange={(event) => setOpcao({ ...opcao, opcao: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="UPK"
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                fullWidth={true}
                                                value={opcao.upk || ''}
                                                onChange={(event) => setOpcao({ ...opcao, upk: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="R$"
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                fullWidth={true}
                                                value={opcao.valor || ''}
                                                onChange={(event) => setOpcao({ ...opcao, valor: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="USD"
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                fullWidth={true}
                                                value={opcao.usd || ''}
                                                onChange={(event) => setOpcao({ ...opcao, usd: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                style={{ height: '100%' }}
                                                color="secondary"
                                                variant="contained"
                                                startIcon={<Add />}
                                                fullWidth={true}
                                                onClick={() => addOpcao()}>
                                                Adicionar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <TableContainer>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Código SAP</TableCell>
                                                    <TableCell>Opção</TableCell>
                                                    <TableCell>UPK</TableCell>
                                                    <TableCell>R$</TableCell>
                                                    <TableCell>USD</TableCell>
                                                    <TableCell>Excluir</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {preco.opcoes && preco.opcoes.map((opcao, index) =>
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.codigo_sap}
                                                                onChange={(event) => changeOpcao('codigo_sap', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.opcao}
                                                                onChange={(event) => changeOpcao('opcao', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.upk}
                                                                onChange={(event) => changeOpcao('upk', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.valor}
                                                                onChange={(event) => changeOpcao('valor', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.usd}
                                                                onChange={(event) => changeOpcao('usd', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton size="small" edge="end" onClick={() => removeOpcao(opcao)}>
                                                                <Delete />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </DialogContent>
                                <DialogActions>
                                    <Button color="primary" onClick={() => setOpcoesDialog(false)}>
                                        Fechar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Grid item xs={6} md={3}>
                                <Button
                                    style={{ height: '100%' }}
                                    color="secondary"
                                    variant="contained"
                                    startIcon={addLoading ? <CircularProgress color="inherit" size="15px" /> : <Add />}
                                    fullWidth={true}
                                    disabled={addLoading}
                                    onClick={() => addPreco()}>
                                    Adicionar
                                </Button>
                            </Grid>
                        </Grid>
                        <Card variant="outlined">
                            <CardContent>
                                <List dense>
                                    {precos.map((preco, index) => (
                                        <ListItem key={index}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <Extension />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={preco.label}
                                                secondary={tiposCampos[preco.tipo_campo as keyof typeof tiposCampos]}
                                            />
                                            <ListItemSecondaryAction>
                                                <IconButton edge="start" onClick={() => editPreco(preco)}>
                                                    <Edit />
                                                </IconButton>
                                                <IconButton disabled={preco.id ? true : false} edge="end" onClick={() => removePreco(preco)}>
                                                    <Delete />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                        <Dialog open={editDialog} fullWidth={true} maxWidth="md">
                            <AppBar style={{ position: 'relative' }}>
                                <DialogTitle>Editar Campo</DialogTitle>
                                <Box px={3} mb={2}>
                                    <Typography variant="body2" color="initial">
                                        Preencha as informações do campo.
                                    </Typography>
                                </Box>
                                <Tabs centered value={tab} onChange={(_event, value) => setTab(value)}>
                                    <Tab label="Campo" />
                                    <Tab label="Opções" />
                                </Tabs>
                            </AppBar>
                            <DialogContent>
                                <Box display={tab === 0 ? 'block' : 'none'} mt={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextField
                                                label="Nome do Campo"
                                                variant="outlined"
                                                size="small"
                                                fullWidth={true}
                                                value={editValue.label || ''}
                                                onChange={(event) => setEditValue({ ...editValue, label: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextField
                                                label="Tipo do Campo"
                                                variant="outlined"
                                                select={true}
                                                fullWidth={true}
                                                value={editValue.tipo_campo || ''}
                                                onChange={(event) => setEditValue({ ...editValue, tipo_campo: event.target.value })}
                                            >
                                                {Object.entries(tiposCampos).map((tipoCampo) => (
                                                    <MenuItem
                                                        key={tipoCampo[0]}
                                                        value={tipoCampo[0]}>
                                                        {tipoCampo[1]}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box display={tab === 1 ? 'block' : 'none'} mt={2}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Código SAP"
                                                variant="outlined"
                                                size="small"
                                                fullWidth={true}
                                                value={opcao.codigo_sap || ''}
                                                onChange={(event) => setOpcao({ ...opcao, codigo_sap: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="Opção"
                                                variant="outlined"
                                                size="small"
                                                fullWidth={true}
                                                value={opcao.opcao || ''}
                                                onChange={(event) => setOpcao({ ...opcao, opcao: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="UPK"
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                fullWidth={true}
                                                value={opcao.upk || ''}
                                                onChange={(event) => setOpcao({ ...opcao, upk: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="R$"
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                fullWidth={true}
                                                value={opcao.valor || ''}
                                                onChange={(event) => setOpcao({ ...opcao, valor: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                label="USD"
                                                variant="outlined"
                                                size="small"
                                                type="number"
                                                fullWidth={true}
                                                value={opcao.usd || ''}
                                                onChange={(event) => setOpcao({ ...opcao, usd: event.target.value })}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                style={{ height: '100%' }}
                                                color="secondary"
                                                variant="contained"
                                                startIcon={<Add />}
                                                fullWidth={true}
                                                onClick={() => addEditOpcao()}>
                                                Adicionar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <TableContainer>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Código SAP</TableCell>
                                                    <TableCell>Opção</TableCell>
                                                    <TableCell>UPK</TableCell>
                                                    <TableCell>R$</TableCell>
                                                    <TableCell>USD</TableCell>
                                                    <TableCell>Excluir</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {editValue.opcoes && editValue.opcoes.map((opcao, index) =>
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.codigo_sap}
                                                                onChange={(event) => changeEditOpcao('codigo_sap', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.opcao}
                                                                onChange={(event) => changeEditOpcao('opcao', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.upk}
                                                                onChange={(event) => changeEditOpcao('upk', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.valor}
                                                                onChange={(event) => changeEditOpcao('valor', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth={true}
                                                                value={opcao.usd}
                                                                onChange={(event) => changeEditOpcao('usd', opcao, event.target.value)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton disabled={opcao.id ? true : false} size="small" edge="end" onClick={() => removeEditOpcao(opcao)}>
                                                                <Delete />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button color="primary" onClick={() => setEditDialog(false)}>
                                    Fechar
                                </Button>
                                <Button
                                    color="primary"
                                    startIcon={saveLoading ? <CircularProgress color="inherit" size="15px" /> : undefined}
                                    disabled={saveLoading}
                                    onClick={() => savePreco()}>
                                    Salvar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                </Page.Content>
            </Page.Section>
        </Page>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            marginRight: theme.spacing(1),
        },
        row: {
            marginBottom: theme.spacing(1)
        },
    })
);

export default PrecosVariantesCreate;